import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getApiErrorMessage } from '@/services/fetcher';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { createContractPricing } from '../data-provider';
import type { LinkPricingParams } from '../models';
import { CACHE_KEYS } from '../types';

export const useCreateContractPricing = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: LinkPricingParams) => createContractPricing(params),
    onError: async (error) => {
      const message = await getApiErrorMessage(error);

      showNotification({
        message: message ?? 'Failed to link pricing to the contract. Please, try again',
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CACHE_KEYS.all });
    },
  });
};
